import { Stack } from "react-bootstrap";
import HalfStar from "./HalfStar.svg";
import FullStar from "./FullStar.svg";
import EmptyStar from "./EmptyStar.svg";

export const StarRating = ({ value = 4.5 }) => {
  const rating = new Array(5)
    .fill(0)
    .map((_, i) =>
      i + 1 <= value ? <FullStar key={i} /> : i + 0.5 <= value ? <HalfStar key={i} /> : <EmptyStar key={i} />,
    );

  return <Stack className="flex-row mb-4">{rating}</Stack>;
};
